import React from "react";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox } from "@mui/material";
import CustomToggleButton from "../global/CustomToggleButton.component";
import MfaDialogBox from "./MfaDialogBox.component";
import { apiErrorHandler } from "../../utils/errorHandler";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import useWindowSize from "../../hooks/useWindowSize";
import { getApiUrl } from "../../utils/apiUrls";
import instance from "../../utils/axios";
import CustomToolTip from "../custom-tooltip/CustomTooltip.component";
import OtpInputField from "../auth/OtpInputField.component";
import { addPad } from "../../utils/helperFn";
import CustomDialogBox from "../global/CustomDialogBox.component";

const resendOtpTime = 60; // TIME IN SECOND
const MfaSetting = ({ t }) => {
  const windowSize = useWindowSize();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [formVal, setFormVal] = React.useState({
    isLoading: false,
    enableAuthenticatorApp: false,
    enableEmailId: false,
    resetMfaModalIsOpen: false,
    modalOpenToggle: false,
    defaultAuthSelection: "", // EMAIL AUTHENTICATION_APP
  });
  const [textBoxStr, setTextBoxStr] = React.useState({ value: "", msg: null });
  const [qrData, setQrData] = React.useState({
    id: null,
    qrcode: null,
    manualCode: null,
  });
  const defaultEmailModalData = React.useMemo(
    () => ({
      emailVerifymodalOpenToggle: false,
      otpHasErrorMsg: null,
      otp: Array(6).fill(""),
    }),
    []
  );
  const [emailData, setEmailData] = React.useState(defaultEmailModalData);

  const [enableTimeFlag, setEnableTimeFlag] = React.useState(false);
  const [secondsLeft, setSecondsLeft] = React.useState(resendOtpTime);
  const clientData = useSelector((state) => state.clientData);
  const endTimeRef = React.useRef(null);

  React.useLayoutEffect(() => {
    if (!enableTimeFlag && emailData?.emailVerifymodalOpenToggle) {
      endTimeRef.current = new Date().getTime() + resendOtpTime * 1000 - 100;
      const interval = setInterval(() => {
        const now = new Date().getTime();
        const timeRemaining = Math.max(
          0,
          Math.round((endTimeRef.current - now) / 1000)
        );
        if (timeRemaining <= 0) {
          setSecondsLeft(resendOtpTime);
          setEnableTimeFlag(true);
          clearInterval(interval);
        } else {
          setSecondsLeft(timeRemaining);
        }
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setSecondsLeft(resendOtpTime);
    }
  }, [enableTimeFlag, emailData?.emailVerifymodalOpenToggle]);

  const textBoxStrHandler = (val) => {
    setTextBoxStr(val);
  };
  const fetchDataForQrCode = async () => {
    try {
      const resData = await axios.post(getApiUrl("getqrcode"), {
        candidateId: user.userId,
      });
      setQrData({
        qrcode: resData.data.data,
        id: resData.data.id,
        manualCode: resData.data.manualCode,
      });
      mfadataHandler({ modalOpenToggle: true });
    } catch (error) {
      const errObj = apiErrorHandler(error);
      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  };
  const mfadataHandler = (val) => {
    setFormVal({ ...formVal, ...val });
  };
  React.useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const res = await instance.get(`${getApiUrl("getCandidateMfaData")}`);
      setFormVal({
        ...formVal,
        candidateProfileId: res.data.candidateProfileId,
        email: res.data.registerEmail,
        enableAuthenticatorApp:
          res.data.authenticationType?.includes("AUTHENTICATION_APP"),
        enableEmailId: res.data.authenticationType?.includes("EMAIL"),
        resetMfaModalIsOpen: false,
        modalOpenToggle: false,
        authenticated: res.data.authenticated,
        defaultAuthSelection: res.data.deFaultAuthenticationType, // EMAIL AUTHENTICATION_APP
      });
    } catch (error) {
      const errObj = apiErrorHandler(error);

      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  };
  const togglebuttonHandler = (key) => {
    let defaultAuthSelection = {};
    if (formVal[key]) {
      if (formVal.defaultAuthSelection === "AUTHENTICATION_APP") {
        defaultAuthSelection = { defaultAuthSelection: null };
      } else if (formVal.defaultAuthSelection === "EMAIL") {
        defaultAuthSelection = { defaultAuthSelection: null };
      }
    }
    const finalObj = {
      ...formVal,
      [key]: !formVal[key],
      ...defaultAuthSelection,
    };
    if (!finalObj.enableAuthenticatorApp && !finalObj.enableEmailId) {
      dispatch(
        openSnackBar({
          msg: t("both_mfa_options_cannot_be_disabled"),
          type: "error",
        })
      );
      return;
    }
    if (key === "enableEmailId") {
      // FOR EMAIL API CALL
      if (finalObj.enableEmailId) {
        saveMfaData(null, {
          authenticationType: finalObj.enableAuthenticatorApp
            ? "EMAIL_AND_AUTHENTICATION_APP"
            : "EMAIL",
          deFaultAuthenticationType: null,
        });
      } else {
        saveMfaData(null, {
          authenticationType: finalObj.enableAuthenticatorApp
            ? "AUTHENTICATION_APP"
            : null,
          deFaultAuthenticationType: null,
        });
      }
    } else {
      // FOR AUTHENTICATION APP API CALL
      if (finalObj.enableAuthenticatorApp) {
        saveMfaData(null, {
          authenticationType: finalObj.enableEmailId
            ? "EMAIL_AND_AUTHENTICATION_APP"
            : "EMAIL",
          deFaultAuthenticationType: null,
        });
      } else {
        saveMfaData(null, {
          authenticationType: finalObj.enableEmailId ? "EMAIL" : null,
          deFaultAuthenticationType: null,
        });
      }
    }
    setFormVal(finalObj);
  };
  const verifyOtpHandler = async (passcode) => {
    try {
      if (formVal.isLoading) return;
      setFormVal({ ...formVal, isLoading: false });
      if (passcode.length !== 6) {
        throw Error("opt_should_have_six_number");
      }
      const resData = await axios.post(`${getApiUrl("verifyQrcode")}`, {
        candidateId: user.userId,
        passCode: passcode,
      });
      mfadataHandler({
        qrIsSet: true,
      });
      dispatch(
        openSnackBar({
          msg: t("successfully_setup_of_app_by_qr"),
          type: "success",
        })
      );
      saveMfaData(null, {
        authenticationType: formVal.enableEmailId
          ? "EMAIL_AND_AUTHENTICATION_APP"
          : "AUTHENTICATION_APP",
        deFaultAuthenticationType: null,
      });
      setFormVal({
        ...formVal,
        isLoading: false,
        modalOpenToggle: false,
        authenticated: true,
        enableAuthenticatorApp: true,
      });
    } catch (error) {
      setFormVal({
        ...formVal,
        isLoading: false,
      });
      setTextBoxStr({
        ...textBoxStr,
        msg: "invalid_passcode_please_try_again",
      });
      const errObj = apiErrorHandler(error);

      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  };
  const actionHandlerWraper = async (e) => {
    if (formVal.isLoading) return;
    e?.preventDefault();
    try {
      if (emailData.otp?.length !== 6) {
        throw Error("opt_should_have_six_number");
      }
      const passCode = Number(
        emailData.otp[0] +
          emailData.otp[1] +
          emailData.otp[2] +
          emailData.otp[3] +
          emailData.otp[4] +
          emailData.otp[5]
      );
      setFormVal({
        ...formVal,
        isLoading: true,
      });

      const resData = await instance.post(`${getApiUrl("verifyEmailOtp")}`, {
        passCode,
        candidateId: user.userId,
      });
      setEmailData(defaultEmailModalData);
      saveMfaData(
        null,
        {
          mettlClientName: clientData?.clientName
            ? clientData?.clientName
            : null,
          sendEmailOtpFromMfaSetting: false,
          resend: false,
          authenticationType: formVal.enableAuthenticatorApp
            ? "EMAIL_AND_AUTHENTICATION_APP"
            : "EMAIL",
          deFaultAuthenticationType: null,
        },
        "email_auth_is_saved_success"
      );
      setFormVal({
        ...formVal,
        isLoading: false,
        enableEmailId: true,
      });
    } catch (error) {
      setFormVal({
        ...formVal,
        isLoading: false,
      });
      const errObj = apiErrorHandler(error);
      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  };
  const saveMfaData = async (actionType, body = {}, successMessage = null) => {
    try {
      const resData = await instance.post(
        `${getApiUrl("saveCandidateMfaData")}${
          actionType === "RESET" ? `?actionType=${actionType}` : ""
        }`,
        body
      );
      if (successMessage === "resend_otp_send_sucessfully") {
        setEnableTimeFlag(false);
      } else if (successMessage === "otp_is_send_email_id") {
        successMessage = "";
        setEmailData({
          ...emailData,
          emailVerifymodalOpenToggle: true,
        });
      } else if (resData.data.status === "SUCCESS" && actionType === "RESET") {
        successMessage = "app_auth_is_reset_successfully";
      }
      if (!!successMessage) {
        dispatch(
          openSnackBar({
            msg: t(successMessage),
            type: "success",
          })
        );
      }
    } catch (error) {
      const errObj = apiErrorHandler(error);

      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  };

  const handleResendOtp = () => {
    if (!enableTimeFlag) return;
      saveMfaData(
      null,
      {
        mettlClientName: clientData?.clientName
          ? clientData?.clientName
          : null,
        sendEmailOtpFromMfaSetting: true,
        resend: true,
        authenticationType: emailData?.emailVerifymodalOpenToggle ? "EMAIL" : "AUTHENTICATION_APP",
        deFaultAuthenticationType: null,
      },
      "resend_otp_send_sucessfully"
    );
  }

  return (
    <div className={`${windowSize.isMobile ? "p-3 my-1" : ""}`}>
      <div>
        <p
          className="cm-sm-txt text-blue-800 my-0 cm-mmc-font text-break"
          style={{ fontSize: "20px", paddingBottom: "6px", paddingTop: "20px" }}
        >
          {t("multi_factor_authorization_mfa_settings")}
        </p>
        <p className="cm-sm-txt text-blue-gray-500 my-0 text-break">
          {t("mfa_can_be_configured_using_the_authenticator_app")}
        </p>
      </div>
      <div
        style={{ width: windowSize.isMobile ? "100%" : "489px" }}
        className="border-bottom border-blue-gray-200 my-32"
      />
      <div className="p-4 mb-4 bg-blue-gray-50 cm-btn-radius">
        <div className="d-flex">
          <div className="flex-grow-1 cm-sm-txt">
            <p className="cm-sm-txt text-blue-700 fw-semibold my-0 text-break">
              {t("set_up_via_authenticator_app")}
            </p>
            <p className="cm-sm-txt text-blue-gray-500 my-0 text-break">
              {t("once_setting_up_you_can_directly_login_account_app")}
            </p>
          </div>
          <CustomToggleButton
            onActive={formVal.enableAuthenticatorApp}
            disabled={false}
            size={"s"}
            onClickHandle={() => {
              if (formVal.authenticated) {
                togglebuttonHandler("enableAuthenticatorApp");
              } else {
                fetchDataForQrCode();
              }
            }}
          />
        </div>
        <div className="my-3 border-top border-blue-gray-200" />
        <div className="mt-3 d-flex">
          <p
            className={`cm-sm-txt fw-medium border border-blue-gray-300 bg-white cm-btn-radius px-3 py-10 mb-0 ${
              formVal.authenticated && formVal.enableEmailId
                ? "cm-pointer text-blue-800"
                : "cm-pointer-none text-blue-gray-500"
            }`}
            onClick={() => {
              saveMfaData("RESET", {});
              setFormVal({
                ...formVal,
                authenticated: false,
                enableAuthenticatorApp: false,
                defaultAuthSelection: "",
              });
            }}
          >
            {t("reset_authentication")}
          </p>
        </div>
        <CustomToolTip
          title={t("enable_email_toolip_default")}
          disableTooltip={
            formVal.enableEmailId && formVal.enableAuthenticatorApp
          }
        >
          <div className="mt-3 d-flex">
            <Checkbox
              checked={formVal.defaultAuthSelection === "AUTHENTICATION_APP"}
              onChange={() => {
                if (!formVal.enableEmailId) return;
                saveMfaData(null, {
                  authenticationType: "EMAIL_AND_AUTHENTICATION_APP",
                  deFaultAuthenticationType:
                    formVal.defaultAuthSelection === "AUTHENTICATION_APP"
                      ? null
                      : "AUTHENTICATION_APP",
                });
                setFormVal({
                  ...formVal,
                  defaultAuthSelection:
                    formVal.defaultAuthSelection === "AUTHENTICATION_APP"
                      ? null
                      : "AUTHENTICATION_APP",
                });
              }}
              inputProps={{ "aria-label": "controlled" }}
              id={"AUTHENTICATION_APP"}
              disableRipple={true}
              className="cm-checkbox-input"
              disabled={
                !(formVal.enableEmailId && formVal.enableAuthenticatorApp)
              }
            />
            <label
              className={`text-break cm-sm-txt fw-medium my-0 ms-2 text-break ${
                formVal.enableEmailId && formVal.enableAuthenticatorApp
                  ? "cm-pointer text-blue-gray-700"
                  : "text-blue-gray-400"
              }`}
              htmlFor={"AUTHENTICATION_APP"}
            >
              {t("set_mfa_via_authenticator_app_default_future_use")}
            </label>
          </div>
        </CustomToolTip>
      </div>
      <div className="mt-10 p-4 mb-4 bg-blue-gray-50 cm-btn-radius">
        <div className="d-flex pb-1">
          <div className="flex-grow-1 cm-sm-txt">
            <p className="cm-sm-txt text-blue-700 fw-semibold my-0">
              {t("set_up_via_email_id")}
            </p>
            <p className="cm-sm-txt text-blue-gray-500 my-0">
              {t("once_setting_up_one_time_password_otp")}
            </p>
          </div>
          <CustomToggleButton
            onActive={formVal.enableEmailId}
            disabled={false}
            size={"s"}
            onClickHandle={() => {
              if (formVal.enableEmailId) {
                togglebuttonHandler("enableEmailId");
              } else {
                saveMfaData(
                  null,
                  {
                    mettlClientName: clientData?.clientName
                      ? clientData?.clientName
                      : null,
                    sendEmailOtpFromMfaSetting: true,
                    resend: false,
                    authenticationType: formVal.enableAuthenticatorApp
                      ? "AUTHENTICATION_APP"
                      : "EMAIL",
                    deFaultAuthenticationType: null,
                  },
                  "otp_is_send_email_id"
                );
              }
            }}
          />
        </div>
        <div className="my-3 border-bottom border-blue-gray-200" />
        <p className="cm-sm-txt fw-medium text-blue-gray-700 me-auto mb-2">
          {t("registered_e_mail_id")}
        </p>
        <span
          className="d-flex px-3 py-10  border border-blue-gray-300 cm-btn-radius"
          style={{ width: windowSize.isMobile ? "100%" : "350px" }}
        >
          <FontAwesomeIcon
            icon={regular("envelope")}
            className="text-blue-gray-700 my-auto"
          />
          <p className="cm-sm-txt fw-medium text-blue-gray-500 ms-10 mb-0 cm-truncate-1">
            {formVal.email}
          </p>
        </span>
        <CustomToolTip
          title={t("enable_email_toolip_default")}
          disableTooltip={
            formVal.enableEmailId && formVal.enableAuthenticatorApp
          }
        >
          <div className="mt-4 d-flex">
            <Checkbox
              checked={formVal.defaultAuthSelection === "EMAIL"}
              onChange={() => {
                if (!formVal.enableEmailId) return;
                saveMfaData(null, {
                  authenticationType: "EMAIL_AND_AUTHENTICATION_APP",
                  deFaultAuthenticationType:
                    formVal.defaultAuthSelection === "EMAIL" ? null : "EMAIL",
                });
                setFormVal({
                  ...formVal,
                  defaultAuthSelection:
                    formVal.defaultAuthSelection === "EMAIL" ? null : "EMAIL",
                });
              }}
              inputProps={{ "aria-label": "controlled" }}
              id={"EMAIL"}
              disableRipple={true}
              className="cm-checkbox-input my-auto"
              disabled={
                !(formVal.enableEmailId && formVal.enableAuthenticatorApp)
              }
            />
            <label
              className={`cm-sm-txt fw-medium my-0 ms-2 text-break  ${
                formVal.enableEmailId && formVal.enableAuthenticatorApp
                  ? "cm-pointer text-blue-gray-700"
                  : "text-blue-gray-400"
              }`}
              htmlFor={"EMAIL"}
            >
              {t("set_the_mfa_via_email_id_as_default_for_future_use")}
            </label>
          </div>
        </CustomToolTip>
      </div>
      {/* DASHBOARD SETTING RESET MFA SETTING */}
      {formVal.modalOpenToggle && (
        <MfaDialogBox
          t={t}
          isOpen={true}
          textBoxStr={textBoxStr}
          textBoxStrHandler={textBoxStrHandler}
          data={qrData}
          mfadataHandler={mfadataHandler}
          onSaveHandler={verifyOtpHandler}
        />
      )}
      {emailData.emailVerifymodalOpenToggle && (
        <CustomDialogBox
          t={t}
          dialogHeading={t("authenticate_email_id")}
          cancelFn={() => {
            setEmailData(defaultEmailModalData);
          }}
          dialogStatus={true}
          disabled={false}
          buttonArrayData={[
            {
              btnName: t("resend_otp"),
              cssSty: `cm-sm-txt fw-medium border border-blue-gray-300 ${
                enableTimeFlag
                  ? "text-blue-800"
                  : "text-blue-gray-500 cm-pointer-none"
              }`,
              handleBtnClick: handleResendOtp,
            },
            {
              btnName: t("submit"),
              cssSty:
                "cm-blue-btn cm-sm-txt cm-trans-btn d-flex flex-row-reverse ms-2 cm-mar-left-icon",
              icon: regular("angle-right"),
              handleBtnClick: (e) => actionHandlerWraper(e),
            },
          ]}
        >
          <form onSubmit={actionHandlerWraper}>
            <p
              className={`fw-medium cm-sm-txt mb-4 text-break ${
                windowSize.isMobile ? "text-white" : "text-blue-gray-700"
              }`}
            >
              {t("enter_verification_code_sent_email_id") + ` "`}
              <span
                className={`${
                  windowSize.isMobile ? "text-white" : "text-blue-800"
                }`}
              >
                {formVal.email}
              </span>
              "
            </p>
            <p
              className={`mb-12 cm-xs-txt  fw-medium ${
                windowSize.isMobile ? "text-white" : "text-blue-gray-700"
              }`}
            >
              {t("enter_digit_verification_code_generated")}
            </p>
            <OtpInputField
              t={t}
              otp={emailData.otp}
              hasErrorMsg={emailData.otpHasErrorMsg}
              mfadataHandler={(data) => {
                setEmailData({ ...emailData, ...data });
              }}
            />
            <div className="mb-0 mt-3 d-flex">
              <CustomToolTip
                title={t("resend_button_enabled_in_some_time_toolip")}
                disableTooltip={enableTimeFlag}
              >
                <p
                  className={`fw-medium cm-sm-txt my-auto ${
                    enableTimeFlag
                      ? "text-decoration-underline text-blue-500 cm-pointer"
                      : "text-blue-gray-500"
                  }`}
                  onClick={handleResendOtp}
                >
                  {t("resend_otp")}
                </p>
              </CustomToolTip>
              {!!secondsLeft && !enableTimeFlag && (
                <p className="my-auto fw-medium cm-sm-txt text-blue-500 ms-3 ps-3 border-start border-blue-gray-300">
                  <span className="text-blue-gray-700">
                    {t("time_remaining")}
                  </span>
                  {" 00:" + addPad(Math.ceil(secondsLeft)) + "s"}
                </p>
              )}
            </div>
          </form>
        </CustomDialogBox>
      )}
    </div>
  );
};

export default MfaSetting;
